import vuetify from "@/main";
import InvoicesSummaryModal from '../review/InvoicesSummaryModal.vue';
import EmailCustomizationModal from "@/modules/modals/EmailCustomizationModal.vue";
import UpdateClientBillingAddressModal from "@/modules/modals/UpdateClientBillingAddressModal.vue";
import MainDraftEditModal from "@/modules/billing/review/editDraft/MainDraftEditModal.vue";
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('billing.review', {
    url: "/review",
    views: {
      '': {
        template: require('./views/review.html')
      }
    },
    redirectTo: 'billing.review.draft'
  });
  addStage('draft');
  addStage('review');
  addStage('approved');
  addStage('quickbooks');
  $stateProvider.state('billing.review.draft.view.item', {
    track: 'Billing:Invoice Item Edit',
    url: "/item/:index",
    views: {
      'edit': {
        template: require('../invoice/views/item.edit.html'),
        controller: 'InvoiceItemEditCtrl'
      }
    },
    params: {
      focus: null,
      item: null,
      ledes: false
    }
  });
  function addStage(stage) {
    $stateProvider.state('billing.review.' + stage, {
      url: "/" + stage
    }).state(`billing.review.${stage}.emailCustomization`, {
      url: "/emailCustomization/{id}",
      views: {
        'invoice@billing.review': vuetify(EmailCustomizationModal)
      },
      params: {
        id: null,
        invoice: null,
        option: null,
        invoices: null,
        clientInfo: null
      }
    }).state(`billing.review.${stage}.clientBillingAddress`, {
      url: "/clientBillingAddress/{id}",
      views: {
        'invoice@billing.review': vuetify(UpdateClientBillingAddressModal)
      },
      params: {
        id: null,
        option: null,
        invoices: null,
        invoiceState: stage
      }
    }).state(`billing.review.${stage}.edit`, {
      url: "/{invoiceId}",
      views: {
        'invoice@billing.review': vuetify(MainDraftEditModal)
      },
      params: {
        invoiceState: stage,
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state(`billing.review.${stage}.invoiceSummary`, {
      url: "/invoiceSummary/{id}",
      views: {
        'invoice@billing.review': vuetify(InvoicesSummaryModal)
      }
    });
  }
}]);